// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { AuditEvent, auditEventsResponseSchema } from '@/audit/api/types';

/**
 * Fetches audit events for an item.
 * Only SERVICE and DEVICE items have audit events; BULK items return an empty array.
 */
export async function getItemAuditEvents(key: string): Promise<AuditEvent[]> {
  const url = `/v1/catalog/item/${key}/audit`;
  const response = await api.get(url);
  const result = await parseResponse(auditEventsResponseSchema, response.data, {
    schemaName: 'ItemAuditEvents',
    endpoint: url,
  });
  return result.events;
}
